
import { RespostaExpedicao } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Expedicao";
import globalMU from "globalMU";
import React from "react";

const estilosTabelas = require('../../../../../estilos/tabelas.module.scss').default

export type NotasFiscaisExpedicaoProps = {
    expedicoes: RespostaExpedicao[];
};

export const NotasFiscaisExpedicao = (props: NotasFiscaisExpedicaoProps) => {

    const headerTabela = () => {
        const mapHeader = ["Data", "Situação", "Histórico", "Transportadora", "Usuário", "Data Previsão", "Responsável"]

        return mapHeader.map((nome) => <th key={nome}>{nome}</th>)
    }

    const itensTabela = (expedicao: RespostaExpedicao) => {
        const mapBody = [
            globalMU.formatDateTime(expedicao.Data), expedicao.DescricaoSituacao, expedicao.Texto, expedicao.Transportadora,
            expedicao.Usuario, globalMU.formatDate(expedicao.DataPrevisaoEntrega),
            expedicao.Responsavel
        ]
 
        return mapBody.map((nome, indice) => <td key={indice}>{nome}</td>)
    }

    const tabelaExpedicao =
        <div className="_my-4">
            <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}>
                <thead>
                    <tr>
                        {headerTabela()}
                    </tr>
                </thead>
                <tbody>
                    {props.expedicoes.map((dado, indice) => (
                        <tr key={indice}>
                            {itensTabela(dado)}
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>

    return (
        <>
            {tabelaExpedicao}
        </>
    )
}